/** @jsx jsx */
import {jsx} from '@emotion/core'
import * as style from './container.style'

const Container = ({children}: any) => {
  return <div css={style.container}>{children}</div>
}

export default Container
